module.exports = __webpack_public_path__ + "static/Hostgator-753cf951907afcaf444a2258fdf70c92.svg";